import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import PvcPage from "../pages/pvc/page";
import AluPage from "../pages/alu/page";
import BoisPage from "../pages/bois/page";
import VoletPage from "../pages/volet/page";
import BaiePage from "../pages/baie/page";
import MotorisationVoletPage from "../pages/motorisation-volet-roulant/page";
import DevisPage from "../pages/devis/page";
import ZonesPage from "../pages/zones/page";
import QuartierJavelPage from "../pages/quartier-javel/page";
import QuartierBeaugrenellePage from "../pages/quartier-beaugrenelle/page";
import QuartierGrenellePage from "../pages/quartier-grenelle/page";
import QuiSommesNousPage from "../pages/qui-sommes-nous/page";
import ContactPage from "../pages/contact/page";
import MentionsLegalesPage from "../pages/mentions-legales/page";
import BlogIndexPage from "../pages/blog/page";
import ArticlePoigneePage from "../pages/blog/reparer-poignee-fenetre-qui-tourne-dans-le-vide/page";
import ArticleVoletPage from "../pages/blog/volet-roulant-bloque-causes-solutions/page";
import ArticleVitragePage from "../pages/blog/double-vitrage-embue-que-faire/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/reparation-fenetre-pvc-paris-15/",
    element: <PvcPage />,
  },
  {
    path: "/reparation-fenetre-aluminium-paris-15/",
    element: <AluPage />,
  },
  {
    path: "/reparation-fenetre-bois-paris-15/",
    element: <BoisPage />,
  },
  {
    path: "/reparation-volet-roulant-paris-15/",
    element: <VoletPage />,
  },
  {
    path: "/reparation-baie-vitree-paris-15/",
    element: <BaiePage />,
  },
  {
    path: "/motorisation-volet-roulant-paris-15/",
    element: <MotorisationVoletPage />,
  },
  {
    path: "/devis-fenetre-paris-15/",
    element: <DevisPage />,
  },
  {
    path: "/zones-intervention-paris-15/",
    element: <ZonesPage />,
  },
  {
    path: "/quartier-javel/",
    element: <QuartierJavelPage />,
  },
  {
    path: "/quartier-beaugrenelle/",
    element: <QuartierBeaugrenellePage />,
  },
  {
    path: "/quartier-grenelle/",
    element: <QuartierGrenellePage />,
  },
  {
    path: "/qui-sommes-nous/",
    element: <QuiSommesNousPage />,
  },
  {
    path: "/contact/",
    element: <ContactPage />,
  },
  {
    path: "/mentions-legales/",
    element: <MentionsLegalesPage />,
  },
  {
    path: "/blog/",
    element: <BlogIndexPage />,
  },
  {
    path: "/blog/reparer-poignee-fenetre-qui-tourne-dans-le-vide/",
    element: <ArticlePoigneePage />,
  },
  {
    path: "/blog/volet-roulant-bloque-causes-solutions/",
    element: <ArticleVoletPage />,
  },
  {
    path: "/blog/double-vitrage-embue-que-faire/",
    element: <ArticleVitragePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;